module.exports = {
      id: "shortvideo-usage",
      viewBox: "0 0 15 19",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#shortvideo",
      toString: function () {
        return this.url;
      }
    }